module.exports = __webpack_public_path__ + "static/logo-398dd2d923f37244ff80ed2be3980ad5.png";